import React from 'react';
import autoBind from 'react-autobind';
import { Toolbar } from 'material-ui/Toolbar';
import { appContainer, Subscribe } from '../../contexts/app';
import AccountBar from './AccountBar';
import BreadcrumbBar from './BreadcrumbBar';
import FacilityBar from './FacilityBar';
import { UserAccountContext } from '../../contexts/userAccount';
import style from './style.js';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    const { windowWidth, appReady, active } = this.props;
    // see style.js for where 587 came from
    return (
      <Toolbar id="NavBar" style={style.toolbar}>
        {windowWidth >= 1100 &&
          appReady &&
          active && (
            <React.Fragment>
              <FacilityBar {...this.props} />
              <BreadcrumbBar {...this.props} />
            </React.Fragment>
          )}
        <AccountBar {...this.props} />
      </Toolbar>
    );
  }
}

export default routeProps => {
  return (
    <UserAccountContext.Consumer>
      {({ subscriptionStatus }) => (
        <Subscribe
          to={[appContainer]}
          render={app => {
            const {
              facilityId,
              buildingId,
              floorId,
              markerId
            } = routeProps.match.params;

            let { active } = subscriptionStatus;
            const windowWidth = app.state.get('windowWidth');
            const sessions = app.state.get('sessions').toList();
            const sidebarOpen = app.state.get('sidebarOpen');
            const currentUser = app.state.get('currentUser');
            const facility =
              active && app.state.getIn(['facilities', facilityId]);
            const building =
              active && app.state.getIn(['buildings', buildingId]);
            const floor = active && app.state.getIn(['floors', floorId]);
            const marker = active && app.state.getIn(['markers', markerId]);
            const facilities = active && app.state.get('facilities').toList();

            return (
              <NavBar
                {...routeProps}
                active={active}
                facility={facility}
                facilities={facilities}
                sessions={sessions}
                sidebarOpen={sidebarOpen}
                toggleSidebar={() => {
                  app.set('sidebarOpen', !sidebarOpen);
                }}
                windowWidth={windowWidth}
                currentUser={currentUser}
                breadcrumbs={{ facility, building, floor, marker }}
              />
            );
          }}
        />
      )}
    </UserAccountContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/containers/NavBar/index.jsx